import React from "react";
import { TS } from "~/Services/TS";

export function SimpleModal({
    isModalOpen,
    title,
    message,
    onCloseModal,
}: {
    isModalOpen: boolean;
    title: string;
    message: string;
    onCloseModal: () => void;
}) {
    return (
        <div className={`modal--medium tst_modal_unhandledError modal-overlay ${isModalOpen && "is-active"}`}>
            <aside className="modal">
                <div className="grid-block vertical">
                    <div className="modal-header" id="tst_simpleErrorModalDialog_header">
                        <h4 className="modal-title">{title}</h4>
                        <a className="close-button" onClick={onCloseModal}>
                            <i className="fa-light fa-xmark"></i>
                        </a>
                    </div>
                    <div className="modal-content grid-block form-content">
                        <div className="grid-block  medium-up-1">
                            <div className="grid-block">
                                <div className="grid-content">
                                    <div id="tst_simpleErrorModalDialog_text" className="modal-content"></div>
                                    <label>{message}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <a className="button float-right secondary" onClick={onCloseModal}>
                            {TS("Close")}
                        </a>
                    </div>
                </div>
            </aside>
        </div>
    );
}
